import { installRestaurantSessionChannel } from "./shared/sessionChannel";
import { PrivateIdentityTree } from "./app/PrivateIdentityTree";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./app/router";
import { installRestaurantNotificationClickBridge } from "./modules/notifications/notificationClickBridge";
import "./app/styles.css";

installRestaurantNotificationClickBridge();

/**
 * `refetchOnWindowFocus` is ON globally, and that is a product decision rather
 * than a default left alone: a waiter's phone sleeps in their pocket between
 * tables, so the moment they wake it is exactly when stale data is most likely
 * and most costly.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 5_000,
      retry: 1,
    },
  },
});

installRestaurantSessionChannel(queryClient);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PrivateIdentityTree><RouterProvider router={router} /></PrivateIdentityTree>
    </QueryClientProvider>
  </StrictMode>,
);
